import { COUNTRYLIST_SEARCH, COUNTRYLIST_PAGE } from '../actions/countrylistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [COUNTRYLIST_SEARCH]: ({ commit }, search) => {
        commit(COUNTRYLIST_SEARCH, search);
    },
    [COUNTRYLIST_PAGE]: ({ commit }, page) => {
        commit(COUNTRYLIST_PAGE, page);
    }
};

const mutations = {
    [COUNTRYLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [COUNTRYLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};